(function () {
  const mobileMedia = window.matchMedia('(max-width: 719px)');

  function hideNotification(notification) {
    notification.classList.remove('show');
    window.setTimeout(function () {
      notification.remove();
    }, 300);
  }

  function showAddedNotification(productTitle) {
    document.querySelectorAll('.wishlist-notification').forEach(function (notification) {
      notification.remove();
    });

    const notification = document.createElement('div');
    notification.className = 'wishlist-notification';
    notification.innerHTML = `
      <div class="wishlist-notification__content">
        <svg class="wishlist-notification__icon" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M3 8.25 6.25 11.5 13 4.75" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="wishlist-notification__text">${productTitle} sepete eklendi</div>
      </div>
      <button class="wishlist-notification__close" type="button" aria-label="Bildirimi kapat">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
          <path d="M9 3 3 9M3 3l6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
    `;

    document.body.appendChild(notification);
    window.requestAnimationFrame(function () {
      notification.classList.add('show');
    });

    notification.querySelector('.wishlist-notification__close').addEventListener('click', function () {
      hideNotification(notification);
    });

    window.setTimeout(function () {
      if (notification.isConnected) hideNotification(notification);
    }, 4000);
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!mobileMedia.matches) return;

      const button = event.target.closest(
        '.product-item__hoverless-quick-view-button[data-quick-shop-trigger="quick-add"]'
      );
      if (!button) return;

      let loadingStarted = button.classList.contains('loading');
      const observer = new MutationObserver(function () {
        if (button.classList.contains('loading')) {
          loadingStarted = true;
          return;
        }

        if (loadingStarted) {
          observer.disconnect();
          showAddedNotification(button.dataset.productTitle || 'Ürün');
        }
      });

      observer.observe(button, { attributes: true, attributeFilter: ['class'] });
      window.setTimeout(function () {
        observer.disconnect();
      }, 10000);
    },
    true
  );
})();
